import React, {Component} from "react";
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {history} from "../../history/History";
import InputMaterial from "../shared/InputMaterial";
import {forgotPassword} from "../../utils/API"
import {set} from "../../redux/Action";
import Loading from "../shared/Loading";
import logo from "../../images/logo-white.png";

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usernameEmail: '',
            notFoundUser: undefined,
            forgotPasswordApi: false,
        }
    }

    componentDidMount() {

    }

    setUsernameEmail(evt) {
        evt.preventDefault();
        if (evt.target.value.length > 64)
            return
        this.setState({
            usernameEmail: evt.target.value,
            notFoundUser: undefined
        })
    }

    forgotPassword = () => {
        if(this.state.usernameEmail === '')
            return
        this.setState({forgotPasswordApi: true})
        forgotPassword(this.state.usernameEmail, (res) => {
            this.setState({forgotPasswordApi: false})
            this.props.dispatch(set(Objects.sendCode, {
                type: 'forgotPassword',
                usernameEmail: this.state.usernameEmail,
            }))
            history.push("/hom/send-code")
        }, () => {
            this.setState({
                forgotPasswordApi: false,
                notFoundUser: false
            })
        })

    }

    render() {
        return (
            <div className="contain-app">
                <div className="logo">
                    <img alt="logo" src={logo}/>
                </div>
                <div className="body-login">
                    <div>
                        <h5>Forgot password</h5>
                        <span className="d-block mt-5 mb-2">Please enter the username or email.</span>
                        <InputMaterial id="usernameEmail"
                                       valid={this.state.notFoundUser}
                                       value={this.state.usernameEmail}
                                       title="Username or Email"
                                       wrongMsg={"Username/Email not found"}
                                       onChange={(evt) => this.setUsernameEmail(evt)}
                        />

                        <div className="mt-3">
                            <button className="waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                    disabled={this.state.forgotPasswordApi} onClick={this.forgotPassword}>
                                <Loading show={this.state.forgotPasswordApi}>
                                    <span>Confirm</span>
                                </Loading>
                            </button>
                        </div>
                        <div className="mt-4">
                            <span className="grey-text">To return to the login page</span>
                            <button className="white-text ml-1" onClick={() => history.goBack()}>Click Here</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
